import { useQuery } from '@apollo/client';
import { TRAVEL_GUIDE_EXISTS } from '../../helpers/graphql/locations';
import Image from 'components/Image';
import { imageProxy } from 'tf-post-parser';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import { slugFromCC } from 'tf-post-parser';
import Link from 'next/link';
import { makeStyles } from 'tss-react/mui';
import shadow from '../../helpers/shadow';

export default function TravelGuideLinkCard({ countryCode, isRounded }) {
  const { data } = useQuery(TRAVEL_GUIDE_EXISTS, {
    variables: {
      countryCode,
    },
  });

  const useStyles = makeStyles()(() => ({
    rounded: {
      borderRadius: 16,
      boxShadow: shadow.lg,
    },
  }));

  const { classes } = useStyles();

  if (
    data &&
    data.locationDetails &&
    data.locationDetails.currencies &&
    data.locationDetails.currencies.length > 0
  )
    return (
      <div className="pt-3">
        <Card
          className={
            'tw-relative tw-h-56' + (isRounded ? ' ' + classes.rounded : '')
          }
        >
          <Image
            alt={data.locationDetails.title}
            src={imageProxy(data.locationDetails.image, 1920, 1200)}
            layout="fill"
            className="tw-brightness-50 tw-object-cover tw-object-center tw-overflow-hidden"
            blurDataURL={data.locationDetails.blur}
            placeholder={data.locationDetails.blur ? 'blur' : undefined}
            sizes="(max-width: 768px) 90vw, (max-width: 1200px) 50vw, 20vw"
          />
          <Link href={`/destinations/${slugFromCC(countryCode)}`}>
            <CardActionArea className="tw-z-10 tw-relative tw-h-56">
              <div className="tw-text-center tw-p-4">
                <div
                  className={
                    'tw-uppercase tw-text-gray-100 tw-font-bold tw-leading-none ' +
                    (data.locationDetails.title.length > 8
                      ? 'tw-text-4xl'
                      : 'tw-text-5xl')
                  }
                >
                  {data.locationDetails.title}
                </div>
                <div className="tw-text-primary-100 tw-text-lg tw-leading-none">
                  travel guide
                </div>
              </div>
            </CardActionArea>
          </Link>
        </Card>
      </div>
    );

  return <></>;
}
